import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import "./scss/common-table1.scss";
import moUser from "@store/user";
import moIndex from "../store/index";

interface IProps {
  leftList: Array<any>;
  rightList: Array<any>;
}
interface IState {}

const CommonTable1 = (props: IProps, state: IState) => {
  const { leftList, rightList } = props;
  const { isLogin } = moUser;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className={["in-common-table-warp-all", !isMock ? "" : "mock-100"].join(
        " "
      )}
    >
      <section className="in-common-table-warp-copy">
        <section
          className="left"
          style={{
            width: `${
              (100 / (leftList?.length + rightList[0]?.length)) *
              leftList?.length
            }%`,
          }}
        >
          {leftList?.map((res: any, r: any) => {
            return (
              <section
                key={r}
                className="item"
                style={{ width: `${100 / leftList?.length}%` }}
              >
                {res?.map((ele: any, e: any) => {
                  return e < 1 && <p key={e}>{ele}</p>;
                })}
              </section>
            );
          })}
        </section>
        <section className="right-warp">
          <section className="item-top">
            <p style={{ width: "50%" }}>招聘量</p>
            <p style={{ width: "50%" }}>招聘薪酬</p>
          </section>
          {rightList?.map((res: any, r: any) => {
            return (
              r < 1 && (
                <section key={r} className="item">
                  {res?.map((ele: any, e: any) => {
                    return (
                      <p
                        key={e}
                        style={{
                          width:
                            rightList[0].length + leftList.length <= 8
                              ? `${100 / rightList[0].length}%`
                              : "12.5%",
                        }}
                      >
                        {ele.toLocaleString()}
                      </p>
                    );
                  })}
                </section>
              )
            );
          })}
        </section>
      </section>
      <section className="in-common-table-warp-copys">
        <section
          className="left"
          style={{
            width: `${
              (100 / (leftList?.length + rightList[0]?.length)) *
              leftList?.length
            }%`,
          }}
        >
          {leftList?.map((res: any, r: any) => {
            return (
              <section
                key={r}
                className="item"
                style={{ width: `${100 / leftList?.length}%` }}
              >
                {res?.map((ele: any, e: any) => {
                  return e >= 1 && <p key={e}>{ele}</p>;
                })}
              </section>
            );
          })}
        </section>
        <section className="right-warp">
          <section className="item-top" style={{ display: "none" }}>
            <p style={{ width: "50%" }}>招聘量</p>
            <p style={{ width: "50%" }}>招聘薪酬</p>
          </section>
          {rightList?.map((res: any, r: any) => {
            return (
              r >= 1 && (
                <section key={r} className="item">
                  {res?.map((ele: any, e: any) => {
                    return (
                      <p
                        key={e}
                        style={{
                          width:
                            rightList[0].length + leftList.length <= 8
                              ? `${100 / rightList[0].length}%`
                              : "12.5%",
                        }}
                      >
                        {ele.toLocaleString()}
                      </p>
                    );
                  })}
                </section>
              )
            );
          })}
        </section>
      </section>
    </section>
  );
};

export default observer(CommonTable1);
